import React from 'react';
import { useSelector } from 'react-redux';
import {
  Link, makeStyles,
} from '@material-ui/core';
import GLOBAL from 'utils/constants/global';
import { useTranslation } from 'utils/modifiedTranslation';
import { useProviderSpecificConfiguration } from 'modules/appConfiguration/useProviderSpecificConfiguration';
import { ProviderFooter } from './ProviderFooter';

const useStyles = makeStyles(() => ({
  root: {
    paddingTop: 10,
    paddingBottom: 20,
  },
  copyRight: {
    textAlign: 'center',
    color: '#000',
    fontSize: 14,
  },
}));

const Footer = () => {
  const { t } = useTranslation();
  const isPartner = useSelector((state) => state.partner.isPartner);
  const { code: providerCode } = useProviderSpecificConfiguration();
  const styles = useStyles({ provider: providerCode });

  if (providerCode) {
    return <ProviderFooter />;
  }

  return (
    <footer className={styles.root}>
      <div className={styles.copyRight}>
        {isPartner ? (
          <Link href="https://leal.health" target="_blank">
            {t('footer.powered_by')}
          </Link>
        ) : (
          t(GLOBAL.footer.copyright.text, {
            currentYear: GLOBAL.footer.copyright.year,
          })
        )}
      </div>
    </footer>
  );
};

export default Footer;
